import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
import ServiceHourDelete from "../delete";
import Delete from "@material-ui/icons/Delete";
import { AttendanceLocalDepartmentQueueServiceTimeComplementException } from "../../../../../../../../../../../../../../../@types/attendance-local-department-queue-service-time-complement-exception";

type AttendanceLocalDepartmentListTableActionsProps = {
    service: AttendanceLocalDepartmentQueueServiceTimeComplementException;
}

export default function AttendanceLocalDepartmentListTableActions({ service }: AttendanceLocalDepartmentListTableActionsProps) {
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    onClick={handleClose}
                    className={classes.menuItem}
                >
                    <ServiceHourDelete
                        service={service}
                        buttonTrigger={
                            <>
                                <Delete htmlColor="#706E7A" />
                                Remover
                            </>
                        }
                    />
                </MenuItem>
            </Menu>
        </>
    );
}